import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { colors } from '../../theme'
import backgroundImage from '../../assets/images/background.jpg'

import { Button } from '../../components'
import { sm } from '../../consts/medias'
import { Form } from 'components/CoForm'

export const Container = styled.div`
  position: relative;
  height: 100vh;

  display: flex;
  justify-content: flex-end;

  background-image: url(${backgroundImage});
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${(props) => props.theme.palette.primary.main};
`

const HocLink = ({ className, ...props }) => (
  <div className={className}>
    <Link {...props} />
  </div>
)

export const StyledLink = styled(HocLink)`
  font-size: 13px;
  margin-top: 8px;
`

export const StyledForm = styled(Form)`
  flex: 1;
  max-width: min(500px, 100%);
  padding: 1rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: ${(props) => props.theme.palette.background.paper};

  .subtitle {
    text-align: center;
    line-height: 150%;
  }

  .subtitle,
  > footer small {
    color: ${colors.color300};
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0.2px;
  }

  > main {
    width: 100%;
    padding: 1rem;

    .fields {
      display: flex;
      flex-direction: column;
      margin: 8px 0;

      label {
        font-size: 13px;
      }

      .MuiFilledInput-root,
      .MuiInputBase-input:-webkit-autofill {
        background-color: transparent !important;
      }

      .MuiFormControl-root,
      .MuiAutocomplete-root {
        flex: 1 1 auto;
        margin: 12px 0;
      }

      .MuiButton-container-root {
        margin-top: 12px;
        display: flex;
      }

      .hidden {
        display: none;
      }
    }

    .links {
      ${StyledLink} {
        &:nth-child(2) {
          margin-top: 0px;
        }
      }
    }
  }

  footer {
    position: absolute;
    bottom: 0;

    margin-top: 60px;
    padding: 8px;

    display: flex;
    justify-content: center;
    align-items: baseline;
  }

  @media ${sm} {
    padding: 24px;

    .subtitle,
    footer {
      display: none;
    }

    > main {
      width: 100%;
      header img {
        margin: 0;
        margin-bottom: 32px;
      }
    }
  }
`

export const SubmitButton = styled(Button)`
  width: 100%;

  height: 45px;
  border-radius: 8px;
  margin: 12px auto;

  span {
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
  }
`

export const PasswordControl = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span.MuiTypography-root,
  a {
    font-size: 13px;
  }

  .MuiSvgIcon-root {
    width: 0.8em;
    height: 0.8em;
  }
`
